import React from "react";
import Lightbox from "react-images";
import { resizeAndConvertImage } from "../../utils/common";

class EventGallery extends React.Component {
  constructor() {
    super();

    this.state = {
      lightboxIsOpen: false,
      currentImage: 0
    };

    this.closeLightbox = this.closeLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.gotoImage = this.gotoImage.bind(this);
    this.handleClickImage = this.handleClickImage.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
  }

  openLightbox(index, event) {
    event.preventDefault();
    this.setState({
      currentImage: index,
      lightboxIsOpen: true
    });
  }
  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false
    });
  }
  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1
    });
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1
    });
  }
  gotoImage(index) {
    this.setState({
      currentImage: index
    });
  }
  handleClickImage() {
    if (this.state.currentImage === this.props.images.length - 1) return;

    this.gotoNext();
  }

  render() {
    let { images, gridNumber = 3 } = this.props;
    let imageUrls = images.map(image => {
      return {
        src: `${image.url}${resizeAndConvertImage(1400)}`
      };
    });
    return (
      <React.Fragment>
        <div className={`gallery grid-container-${gridNumber}`}>
          {images.map((image, idx) => (
            <a
              href="#"
              className="w-inline-block w-lightbox"
              key={image.id}
              onClick={e => this.openLightbox(idx, e)}
            >
              <img
                src={`${image.url}${resizeAndConvertImage(600)}`}
                alt={image.alt}
                style={{ width: "205px", height: "136px", objectFit: "cover" }}
              />
            </a>
          ))}
        </div>
        <Lightbox
          images={imageUrls}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen}
          onClickImage={this.handleClickImage}
          onClickNext={this.gotoNext}
          onClickPrev={this.gotoPrevious}
          onClickThumbnail={this.gotoImage}
          onClose={this.closeLightbox}
          preloadNextImage={true}
          showThumbnails={true}
        />
      </React.Fragment>
    );
  }
}

export default EventGallery;
